
import Header from "../../components/Header/Header";
import ContactUs from "../../components/ContactUs/ContactUs";
import Footer from "../../components/Footer/Footer";

export const ContactUsPage = () => {

  return (
    <div >
      <Header/>
      <ContactUs/>
      <Footer/>
    </div>

  );
};


